




























































import { Vue, Component } from 'vue-property-decorator'
import { Button, Select, SelectOption } from '@alpha/ink'
import AddProject from '@/components/AddProject/AddProject.vue'
import store from '@/store'
import * as ui from '@/types/frontend'

@Component({
  components: {
    Select,
    AddProject,
    Button
  }
})
export default class SelectWorkspaceAndProject extends Vue {
  loadingProjects = false
  newProject:boolean = false

  get workspace () {
    return store.state.testCreation.workspace
  }

  get projectId () {
    return store.state.testCreation.projectId
  }

  get allWorkspaces () {
    return store.getters.user.allWorkspaces
  }

  get projectOptions (): SelectOption[] {
    const projects: SelectOption[] = this.projects.map(project => ({
      label: project.title,
      value: project.id
    }))
    projects.unshift({
      label: 'Select a project (not required)',
      value: null
    })
    return projects
  }

  get workspaceOptions (): SelectOption[] {
    // Sometimes admins are navigated away from their list of workspaces
    // and we need to add that as an option to the list
    let currentWorkspaceHasOption = false
    const currentWorkspace = store.state.workspace.workspace

    const options = this.allWorkspaces.map(ws => {
      if (ws.id === currentWorkspace.id) {
        currentWorkspaceHasOption = true
      }
      return {
        label: ws.name,
        value: ws.id
      }
    })

    // Add current workspace as option
    if (!currentWorkspaceHasOption && currentWorkspace.id) {
      options.push({
        label: currentWorkspace.name,
        value: currentWorkspace.id
      })
    }

    return options
  }

  get selectedWorkspaceOption () {
    return this.workspaceOptions
      .find(op => op.value === this.workspace?.id)
  }

  get selectedProjectOption () {
    return this.projectOptions
      .find(op => op.value === this.projectId)
  }

  get projects () {
    return store.state.testCreation.projects
  }

  get newProjectError () {
    return store.state.testCreation.newProjectError
  }

  setNewProject (value: boolean) {
    this.newProject = value
    if (value) {
      this.newProjectChange({ title: '', description: '' })
    } else {
      store.commit.testCreation.setNewProject(null)
    }
  }

  newProjectChange (projectPayload: ui.ProjectPayload) {
    store.commit.testCreation.setNewProject(projectPayload)
  }

  async selectWorkspaceOption (option: SelectOption) {
    if (option && option.value) {
      return this.loadWorkspace(option.value.toString())
    }
  }

  selectProjectOption (option: SelectOption) {
    this.setProject(option?.value?.toString())
  }

  async setProject (projectId?: string) {
    if (!projectId) return console.error('Missing project Id to set project.')
    this.loadingProjects = true
    this.$emit('loading', true)
    await store.dispatch.testCreation.setProject(projectId)
    this.loadingProjects = false
    this.$emit('loading', false)
  }

  async mounted () {
    if (this.$route.params.workspaceId) {
      await this.loadWorkspace(this.$route.params.workspaceId)
    }
    if (this.$route.params.projectId) {
      this.setProject(this.$route.params.projectId)
    }
  }

  async loadWorkspace (workspaceId: string) {
    this.loadingProjects = true
    this.$emit('loading', true)
    await store.dispatch.testCreation.loadWorkspace(workspaceId)
    this.loadingProjects = false
    this.$emit('loading', false)
  }
}
